import React from 'react';
import {View, StyleSheet} from 'react-native';
import {Pill, disabledOpacity, Colors} from '../index';
import {ComponentProps} from './ComponentProps';

interface InputPillProps extends ComponentProps {
  borderColor: string;
  // default: false
  isValid?: boolean;
  // default: true
  isEnabled?: boolean;
  paddingHorizontal?: number;
}

export const InputPill = (props: React.PropsWithChildren<InputPillProps>) => {
  const isEnabled = props.isEnabled ?? true;
  const borderColor = props.isValid ?? true ? props.borderColor : Colors.error;
  const opacity = isEnabled ? 1 : disabledOpacity;
  return (
    <View style={props.containerStyle} pointerEvents={isEnabled ? 'auto' : 'none'}>
      <Pill borderColor={borderColor} containerStyle={{opacity: opacity}} paddingHorizontal={props.paddingHorizontal}>
        <View style={inputPillStyles.pillContent}>{props.children}</View>
      </Pill>
    </View>
  );
};

const inputPillStyles = StyleSheet.create({
  pillContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
});
